import { render, staticRenderFns } from "./AdminBillingEmployeeFees.vue?vue&type=template&id=006700e0&scoped=true"
import script from "./AdminBillingEmployeeFees.vue?vue&type=script&lang=ts"
export * from "./AdminBillingEmployeeFees.vue?vue&type=script&lang=ts"
import style0 from "./AdminBillingEmployeeFees.vue?vue&type=style&index=0&id=006700e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006700e0",
  null
  
)

export default component.exports